import { nexusStore } from "src/store/nexus";
import { useStore } from "zustand";

export const useNexus = () => {
  const nexus = useStore(nexusStore);
  return nexus;
};
